"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressTransactionsListResponseToJSON = exports.AddressTransactionsListResponseFromJSONTyped = exports.AddressTransactionsListResponseFromJSON = void 0;
function AddressTransactionsListResponseFromJSON(json) {
    return AddressTransactionsListResponseFromJSONTyped(json, false);
}
exports.AddressTransactionsListResponseFromJSON = AddressTransactionsListResponseFromJSON;
function AddressTransactionsListResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'limit': json['limit'],
        'offset': json['offset'],
        'total': json['total'],
        'results': json['results'],
    };
}
exports.AddressTransactionsListResponseFromJSONTyped = AddressTransactionsListResponseFromJSONTyped;
function AddressTransactionsListResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'limit': value.limit,
        'offset': value.offset,
        'total': value.total,
        'results': value.results,
    };
}
exports.AddressTransactionsListResponseToJSON = AddressTransactionsListResponseToJSON;
//# sourceMappingURL=AddressTransactionsListResponse.js.map